import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface TiktokAccountVM {
  uid: string;               // open_id
  username?: string | null;  // username
  name?: string | null;      // display_name
  picture?: string | null;   // avatar_url
}

@Component({
  selector: 'app-tiktok',
  templateUrl: './tiktok.component.html',
  styleUrls: ['./tiktok.component.scss']
})
export class TiktokComponent {
  isMobile = false;

  ngOnInit() {
    this.isMobile = window.innerWidth <= 768;
  }

  @Input() tiktokAccounts: TiktokAccountVM[] = [];
  @Input() visible = false;
  @Input() loading = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() addTiktokAccount = new EventEmitter<void>();
  @Output() removeTiktokAccountEvent = new EventEmitter<TiktokAccountVM>();
  @Output() close = new EventEmitter<void>();

  onAddTikTokAccount(): void {
    this.addTiktokAccount.emit();
  }

  onRemoveTikTokAccount(account: TiktokAccountVM): void {
    this.removeTiktokAccountEvent.emit(account);
  }

  trackByUid = (_: number, a: TiktokAccountVM) => a.uid;
}
